import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { LIST_CONTACT_NAME } from "./permitsConfig";
import { WELLS_BASE_URL } from "../wellsManagement/wellsConfig";

export const DROUGHT_ZONES_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/drought-declaration/drought-zones`;

export function usePermitLookups() {
  const { getAccessTokenSilently } = useAuth0();

  const contactsQuery = useQuery(["contacts"], async () => {
    const token = await getAccessTokenSilently();
    const res = await axios.get(LIST_CONTACT_NAME, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  const wellsQuery = useQuery(["wells"], async () => {
    const token = await getAccessTokenSilently();
    const res = await axios.get(WELLS_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  const droughtZonesQuery = useQuery(["drought-zones"], async () => {
    const token = await getAccessTokenSilently();
    const res = await axios.get(DROUGHT_ZONES_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  const allocationProfilesQuery = useQuery(
    ["allocation-profiles-with-items"],
    async () => {
      const token = await getAccessTokenSilently();
      // Use the full allocation profiles API that includes monthly items
      const res = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/allocation-profiles`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { includeInactive: false }, // Only get active profiles for permits
        }
      );
      return res.data;
    }
  );

  return {
    contacts: contactsQuery.data || [],
    wells: wellsQuery.data || [],
    droughtZones: droughtZonesQuery.data || [],
    allocationProfiles: allocationProfilesQuery.data || [],
  };
}
